import CircleFilled from 'owa-fluent-icons-svg/lib/icons/CircleFilled';
import CircleRegular from 'owa-fluent-icons-svg/lib/icons/CircleRegular';
import loc from 'owa-localize';
import { createMailAppButton } from '../../util/createMailRibbonButton';
import { getStore, lazyChangeNoteColor } from 'owa-notes-store';
import { notesColorMap } from 'owa-notes-components/lib/utils/getChangeColorMenuProps';
import type { MenuItemControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/controls/Menu';

/**
 * The section for the change note color flyout menu in ribbon.
 */
export default function getChangeNoteColorSections(): MenuItemControlProps[] {
    const controls: MenuItemControlProps[] = [];
    const selectedNoteColor = getStore().selectedNoteColor;

    // Loop through Notes colorMap and create a mail button for each color.
    Object.values(notesColorMap).map(colorMapValue => {
        let colorText = loc(colorMapValue.text);
        controls.push(
            createMailAppButton(
                'notesColor_' + colorText,
                colorText /* label */,
                undefined /* tooltip */,
                false /* isPopout */,
                () => {
                    lazyChangeNoteColor.importAndExecute(colorMapValue.color, 'NotesFolder');
                },
                undefined /* keytipProps */,
                selectedNoteColor == colorMapValue.color ? CircleFilled : CircleRegular,
                colorMapValue.styleColor
            )
        );
    });

    return controls;
}
